import utils from '@/_modules/utils';
import {gsap, Quart} from 'gsap/all';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

class _gnav {
  constructor() {}

  once() {
    this.isOpen = false;
    this.adjust = 0;
    this.pastScrollY = 0;

    // ナビ全体
    this.el = document.getElementById('c-gnav');
    
    // PC　ヘッダーナビ
    this.header = document.getElementById('c-header');
    this.header.querySelectorAll('.c-header__link a').forEach(this.settingAnchor.bind(this));

    // スマホ モーダルナビ
    this.modal = document.getElementById('c-gnav__modal');
    this.modal.querySelectorAll('.block-link a').forEach(this.settingAnchor.bind(this));
    this.btnToggle = document.getElementById('c-trigger');
    this.btnToggle.addEventListener('click', this.toggleModal.bind(this));
  }

  start() {
    // URLアンカー
    let id = location.hash;
    if (id.indexOf('#anchorto_') > -1) {
      id = id.replace('#anchorto_', '');
      if (id) {
        requestAnimationFrame(this.gotoAnchor.bind(this, id));
      }
    }
  }

  settingAnchor(el, i) {
    const anchor = el.getAttribute('data-anchor');
    if (anchor) {
      let linkPath = utils.getUrlPath(el.href);
      linkPath = linkPath.split('#')[0];
      if (location.pathname === linkPath) {
        // 現在のページがリンク先なのでアンカーリンクを有効にする
        el.addEventListener('click', this.clickAnchor.bind(this, anchor));
      }
    }
  }

  clickAnchor(id, e) {
    if (e) e.preventDefault();
    this.closeNav();
    this.gotoAnchor(id);
  }

  gotoAnchor(id) {
    console.log(id);
    const target = document.querySelector(`#${id}`);
    if (target) {
      const offset = utils.getOffsetTop(target);
      gsap.to(window, {
        duration: 0.7,
        delay: 0.3,
        scrollTo: {
          y: offset.top - this.adjust,
          autoKill: false,
        },
        ease: Quart.easeOut
      });
    }
  }

  toggleModal() {
    if (this.isOpen) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }

  openNav() {
    if (this.isOpen) return;
    this.isOpen = true;
    gNGF.rootHTML.classList.add('is-gnav--modal-open');

    gsap.fromTo(this.modal, {
      display: 'flex',
      opacity: 0,
    }, {
      duration: 0.7,
      opacity: 1,
      ease: Quart.easeOut,
      onComplete: this.openNavComp.bind(this),
    });
  }

  openNavComp() {
    this.pastScrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;

    const body = document.body;
    body.style.overflow = 'hidden';
    //body.style.overflowX = 'hidden';
    //body.style.overflowY = 'scroll';
    //body.style.position = 'fixed';
    //body.style.height = 'auto';

    //gEvent.emit('OPEN_GNAV');
  }

  closeNav() {
    if (!this.isOpen) return;
    this.isOpen = false;
    gNGF.rootHTML.classList.remove('is-gnav--modal-open');

    gsap.to(this.modal, {
      duration: 0.7,
      display: 'none',
      opacity: 0,
      ease: Quart.easeOut,
      onComplete: this.closeNavComp.bind(this),
    });

    const body = document.body;
    body.style.overflowX = '';
    body.style.overflowY = '';
    body.style.position = '';
    body.style.height = '';

    window.scrollTo(0, this.pastScrollY);

    //gEvent.emit('CLOSE_GNAV');
  }

  closeNavComp() {
    //this.el.classList.remove('c-gnav--modal-open');
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  resize() {
    this.closeNav();
    this.getHeight100();
    const winW = window.innerWidth;
    if (utils.getMatchMedia()) {
      this.adjust = (100 / 750) * window.innerWidth;
      ///////////////
      // SP
      ///////////////
      if (this.ispc && winW !== this.pastWidth) {
        //this.resetPc();
      }
    } else {
      this.adjust = 140;
      ///////////////
      // PC
      ///////////////
      if (!this.ispc) {
        //this.initPc();
      }
    }

    this.pastWidth = window.innerWidth;
  }
}

const gnav = new _gnav();

export default gnav;